import useLocale from '@/hooks/useLocale';
import buildShopSubdomainUrl from '@/utils/shopSubdomain';
import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

export const useCartUrl = () => {
  const locale = useLocale();
  const searchParams = useSearchParams();
  const a11yEnabled = searchParams?.get('UsableNetAssistive') === 'true';

  const cartHref = useMemo(() => {
    const href = buildShopSubdomainUrl('/cart', locale as string);

    if (!a11yEnabled) return href;

    return href.includes('?')
      ? `${href}&UsableNetAssistive=true`
      : `${href}?UsableNetAssistive=true`;
  }, [a11yEnabled, locale]);

  return cartHref;
};
